




















































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import eventBus from '@/utils/eventBus';
import HTTPStatus from '@/constants/httpStatus';
import { ILocation } from '@/models/location';
import ConfirmationDelete from '@/componentsV2/templates/Modals/InviteMerchantSignup/ConfirmationDelete.vue';
import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';
import { IOfferEdit } from '@/models/offer';
import LazyImage from '@/componentsV2/atoms/LazyImage/LazyImage.vue';

@Component({
  components: {
    Typography,
    ConfirmationDelete,
    LazyImage
  }
})
export default class ConfirmationDeleteOffer extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel
) {
  @Prop() readonly code!: string;
  @Prop() offer!: IOfferEdit;

  loading = false;

  onClose() {
    eventBus.$emit('closeModal');
  }

  get emptyStateImageSrc() {
    return require(`@/assets/img/image-placeholder.png`);
  }

  locationsMap(locations: ILocation[]) {
    return locations.map(location => `📍 ${location.name}`).toString();
  }

  async handleDeleteOffer() {
    this.loading = true;

    const { status } = await this.service.deleteOffer(this.code, this.offer.id);

    if (status === HTTPStatus.OK) {
      this.$notification('The Offer has been removed!', 'success');
      eventBus.$emit('inviteMerchantOfferRemoved', this.offer.id);
    }

    this.loading = false;
    this.onClose();
  }
}
